/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/search_mobile': {
    width: 16,
    height: 16,
    viewBox: '0 0 24.5 24.5',
    data: '<g data-name="Layer 2"><path pid="0" d="M2.91 2.91a10 10 0 000 14.09 9.76 9.76 0 0012 1.49.42.42 0 01.5.07l5.07 5.06c1 1 2.42 1.25 3.31.36l.16-.16c.89-.89.65-2.31-.36-3.31l-5.07-5.11a.41.41 0 01-.06-.49 9.76 9.76 0 00-1.46-12 10 10 0 00-14.09 0zm12.22 1.83a7.35 7.35 0 11-10.39 0 7.36 7.36 0 0110.39 0z" _fill="#e25046" fill-rule="evenodd" data-name="Layer 1"/></g>'
  }
})
